import axios from "axios";
import Header from "./Component/Header";
import { useEffect, useState } from "react";
import { handleGetApiGF, Toast } from "./Component/Utils/general-function";
import Loader from "./Component/Utils/Loader";
import { Link } from "react-router-dom";

const Test2 = () => {
  const [searchtxt, setSearchtxt] = useState("");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);

  const OnChange = (e) => {
    setSearchtxt(e.target.value.toUpperCase());
  };

  const rcSearcFetch = async () => {
    if (!(searchtxt || "").trim())
      return Toast(false, "", "Please enter car number");
    setLoading(true);
    let obj = new URLSearchParams({
      Carno: searchtxt,
    }).toString();
    const res = await handleGetApiGF({
      url: "/api/RCHistory/TestGetRCHistory?" + obj,
    });
  };
  // const rcSearcFetch = async () => {
  //   if (!(searchtxt || "").trim())
  //     return Toast(false, "", "Please enter car number");
  //   setLoading(true);
  //   let url = "https://api.dhboss.com/apicall/rc_verification_check/"; // 1
  //   // let url = "https://api.dhboss.com/apicall/rto_vehicle_info/"; // 0.50
  //   const res = await axios.post(
  //     url,
  //     {
  //       vehicleId: searchtxt,
  //       apikeyfill:
  //         // "3lsSCR1jYyjBJAYndkNxo9vRKrFcEE21Zfkxou05nXf3UZTRkECGrCQ0Dhik0NZMjeRqPF",
  //         "ktvPeaE9DtcrpU01nvBAGktZ7gNFMLM8HWMkuM8PB8gYcVX7Ep19NTcBFYUVw0v4VX3iax", // carthi
  //     },
  //     {
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //         //    "Content-Type": "application/json"
  //       },
  //     },
  //   );

  //   if (res?.data?.status !== "200" || res?.data?.type !== "Success") {
  //     setLoading(false);
  //     return Toast(false, "", res?.data?.message || "Something went wrong!");
  //   }
  //   setData(res?.data?.detail);
  //   setLoading(false);
  // };

  const greenClr = "#3d903dff";
  const redClr = "#E62E2D";
  return (
    <div>
      <Header />

      {loading ? <Loader /> : null}
      <div className="content">
        <div className="text-center">
          <h2 className="page-title">Rc search Demo</h2>
        </div>
        <div className="input-group mt-2">
          <input
            type="text"
            className="form-control"
            placeholder="RC Number"
            name="searchtxt"
            value={searchtxt}
            onChange={OnChange}
          />
          <button
            className="btn rc-submit"
            type="submit"
            onClick={rcSearcFetch}
          >
            Submit
          </button>
        </div>
        {/* Display the API response data */}

        {data ? (
          <div className="mt-4 d-grid gap-2" id="cardetails">
            <div className="rc-div">
              <span className="rc-property">Vehicle Number </span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "700" }}>
                {data?.registrationNumber}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Status
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{
                  fontWeight: "500",
                  color: ["ACTIVE", "A", "Y"].includes(data?.rcStatus)
                    ? greenClr
                    : redClr,
                }}
              >
                {data?.rcStatus}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Insurance Company</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.insuranceCompany}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Insurance Upto</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {new Date(data?.insuranceUpTo).toLocaleDateString("es-CL")}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">PUCC Valid Upto</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.pucUpTo}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Model</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {data?.brand?.make_display}
                {data?.model?.model_display}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Vehicle Class</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.rc_vh_class_desc}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Owner Number
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {data?.rc_owner_sr}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Owner</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.rc_owner_name_masked}
              </span>
            </div>

            {/* <div className="rc-div">
              <span className="rc-property">Father Name</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.ownerFatherName ? maskName(data.ownerFatherName) : "-"}
              </span>
            </div> */}

            {/* <div className="rc-div">
              <span className="rc-property">Chassis Number</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {replaceLastFiveCharacters(data?.chassis)}
              </span>
            </div> */}

            {/* <div className="rc-div">
              <span className="rc-property">Engine Number</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {replaceLastFiveCharacters(data?.engine)}
              </span>
            </div> */}
            <div className="rc-div">
              <span className="rc-property">Fuel Type </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {data?.fuelType}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Color</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {data?.color}
              </span>
            </div>

            {/* <div className="rc-div">
              <span className="rc-property">Emission Norm</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.normsType}
              </span>
            </div> */}
            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Manufactured on
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {data?.manufacturingMonthYr}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Registered Date </span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {new Date(data?.registeredAt).toLocaleDateString("es-CL")}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Expiry Date</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {new Date(data?.rcExpiryDate).toLocaleDateString("es-CL")}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Tax Paid Upto</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.taxUpTo}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">RTO </span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.RTO?.rto_code} {data?.registeredPlace}
              </span>
            </div>
            {/* <div className="rc-div">
              <span className="rc-property">Cubic Capacity</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.vehicleCubicCapacity}
              </span>
            </div> */}
            <div className="rc-div">
              <span className="rc-property">Seating Capacity</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.ds_details[0]?.variant?.variant_display_name}
              </span>
            </div>
            {/* <div className="rc-div">
              <span className="rc-property">Noc data</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {data?.nocDetails ? data?.nocDetails : "-"}
              </span>
            </div> */}
            {/* TOP SERVICE */}
            <span
              className="title  text-center d-flex  justify-content-center flex-column"
              style={{ paddingTop: "2px", fontWeight: "700", color: redClr }}
            >
              Top Services
            </span>

            <div className="rc-div rc-gird-2">
              <Link
                to="/MakeCustomizepost"
                className="d-flex align-items-start gap-1"
              >
                {/* <img
                            src="assets/images/check.png"
                            style={{ maxHeight: "16px", marginTop: "3px" }}
                            alt="check"
                          /> */}

                <i
                  className="bx bx-check"
                  style={{
                    maxHeight: "16px",
                    marginTop: "3px",
                    color: redClr,
                    fontWeight: "bold",
                  }}
                ></i>
                <span className="rc-property w-100">
                  Create Professional Social Media Post
                </span>
              </Link>
              <Link className="d-flex align-items-start gap-1">
                {/* <img
                            src="assets/images/check.png"
                            style={{ maxHeight: "16px", marginTop: "3px" }}
                            alt=""
                          />{" "} */}
                <i
                  className="bx bx-check"
                  style={{
                    maxHeight: "16px",
                    marginTop: "3px",
                    color: redClr,
                    fontWeight: "bold",
                  }}
                ></i>
                <span className="rc-property w-100">Carthi Perfume</span>
              </Link>
            </div>
            {/* carthi sites */}
            <div className="rc-gird-2 border-0">
              <a
                href="https://m.carthi.in/"
                className="d-flex align-items-center "
                target="_blank"
                rel="noreferrer"
              >
                <div className="d-flex justify-content-left align-items-center">
                  <span
                    className="rc-property w-100"
                    style={{
                      color: redClr,
                    }}
                  >
                    m.carthi.in
                  </span>
                  <span
                    class="material-symbols-outlined"
                    style={{ fontSize: "16px" }}
                  >
                    arrow_outward
                  </span>
                </div>
              </a>
              <a
                href="https://carthi.in/"
                className="d-flex align-items-center "
                target="_blank"
                rel="noreferrer"
              >
                <div className="d-flex justify-content-left align-items-center">
                  <span
                    className="rc-property w-100"
                    style={{
                      color: redClr,
                    }}
                  >
                    carthi.in
                  </span>
                  <span
                    class="material-symbols-outlined"
                    style={{ fontSize: "16px" }}
                  >
                    arrow_outward
                  </span>
                </div>
              </a>
            </div>
          </div>
        ) : (
          <div
            className="text-center mt-2"
            style={{ color: "#ff002a", fontWeight: "500" }}
          >
            <label>
              "We're working on retrieving the information. Please check back
              shortly."
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default Test2;
